import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import cssText from '!!raw-loader!./ComingSoon.raw.css';
var styleElement = null;
var instancesCount = 0;
export default (function () {
    var launchDate = new Date("2025-07-01T00:00:00").getTime();
    var _a = useState(""), timeLeft = _a[0], setTimeLeft = _a[1];
    useEffect(function () {
        instancesCount += 1;
        if (!styleElement) {
            // Create and inject style once
            styleElement = document.createElement("style");
            styleElement.type = "text/css";
            styleElement.appendChild(document.createTextNode(cssText));
            document.head.appendChild(styleElement);
        }
        return function () {
            instancesCount -= 1;
            if (instancesCount === 0 && styleElement) {
                document.head.removeChild(styleElement);
                styleElement = null;
            }
        };
    }, []);
    useEffect(function () {
        var updateCountdown = function () {
            var now = new Date().getTime();
            var distance = launchDate - now;
            if (distance < 0) {
                setTimeLeft("We're live now!");
                clearInterval(interval);
                return;
            }
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            setTimeLeft("".concat(days, "d ").concat(hours, "h ").concat(minutes, "m ").concat(seconds, "s"));
        };
        updateCountdown(); // initial call
        var interval = setInterval(updateCountdown, 1000);
        return function () { return clearInterval(interval); }; // cleanup on unmount
    }, [launchDate]);
    return _jsxs(_Fragment, { children: [_jsx("h1", { children: "Coming Soon" }), _jsx("p", { children: "Our website is under construction. We'll be here soon with our new awesome site." }), _jsx("div", { className: "countdown", id: "countdown", children: timeLeft })] });
});
